import { ComponentProps } from "react";

import { Box } from "@design-system/Box/Box";
import { Card } from "@design-system/Card/Card";
import { Stat } from "@design-system/Stat/Stat";

type Props = {
  icon: ComponentProps<typeof Stat>["icon"];
  title: ComponentProps<typeof Stat>["title"];
  value: ComponentProps<typeof Stat>["value"];
  isLoading?: boolean;
  onOpenDetails?: ComponentProps<typeof Stat>["onOpenDetails"];
};

export const StatCard = ({
  icon,
  title,
  value,
  isLoading = false,
  onOpenDetails,
}: Props) => {
  return (
    <Card>
      <Card.Body grow>
        <Box grow={1} align="center">
          <Stat
            icon={icon}
            title={title}
            value={value}
            isLoading={isLoading}
            onOpenDetails={onOpenDetails}
          />
        </Box>
      </Card.Body>
    </Card>
  );
};
